var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 48,
    viewBox: "0 0 58 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.389 47.249V25.04H38.744V0H18.645V17.6215H0V47.249H57.389ZM48.0665 40.331V45.795H55.935V40.331H48.0665ZM38.744 40.331V45.795H46.6125V40.331H38.744ZM29.5465 26.494V45.795H37.29V26.494H29.5465ZM20.099 26.494V45.795H28.092V26.494H20.099ZM1.454 40.331V45.795H18.645V40.331H1.454ZM38.744 33.4125V38.8765H46.6125V33.4125H38.744ZM1.454 33.4125V38.8765H18.645V33.4125H1.454ZM48.0665 33.4125V38.8765H55.935V33.4125H48.0665ZM38.744 26.494V31.958H55.935V26.494H38.744ZM1.454 26.494V31.958H18.645V26.494H1.454ZM1.454 19.0755V25.04H18.645V19.0755H1.454ZM20.099 1.454V25.04H37.29V1.454H20.099Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.922ae6965c117d11ac8c151832ec0263.svg";
export { ForwardRef as ReactComponent };